<template>
  <div class="packages-block">
    <h3 class="packages-block__block-heading">{{ blockHeading }}</h3>

    <div class="packages-block__inner-wrapper">
      <h4 class="packages-block__list-heading">{{ listHeading }}</h4>

      <ul class="packages-block__list">
        <li
          v-for="(listItem, index) in listItems"
          :key="index"
          class="list-copy packages-block__list-item"
        >
          {{ listItem }}
        </li>
      </ul>

      <h4 class="packages-block__list-heading">
        <b>{{ priceDescription }}</b>
      </h4>
    </div>

    <div v-if="!this.loginstate">
      <router-link :to="buttonLink" v-if="buttonText != null">
        <AppButton :text="buttonText" class="packages-block__button" />
      </router-link>
    </div>
  </div>
</template>


<script>
import AppButton from "@/components/ui/AppButton";

export default {
  name: "PlansBlock",
  props: {
    blockHeading: String,
    listHeading: String,
    listItems: Array,
    priceDescription: String,
    buttonText: String,
    buttonLink: String,
  },
  components: {
    AppButton,
  },
  data() {
    return {
      loginstate: false,
    };
  },
  mounted() {
    if (sessionStorage.getItem("_khonsu_user_login_status")) {
      this.loginstate = true;
    } else {
      this.loginstate = false;
    }
  },
};
</script>
